export default __webpack_public_path__ + "static/assets/f8e0214f95236c4941e367855b041f92.png";